const axios = require('axios');
const config = require('../../../config');
const { timeout } = config.get('apiGateway');
const ServiceResponse = require('../../models/ServiceResponse');

const buildUrl = async (userId, lat, lng, countryId, page) => {
  const params = {
    latitude: lat,
    longitude: lng,
    country_id: countryId,
    page,
  };

  if (userId !== null) {
    params.user_id = userId;
  }
  const queryString = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');
  return `/promotions-section/api/v2/incentives/food?${queryString}&size=10`;
};

const getVendorsFood = async (userId, lat, lng, countryId, page) => {
  try {
    const urlFood = await buildUrl(userId, lat, lng, countryId, page);
    const { data } = await axios.get(urlFood, { timeout });

    return new ServiceResponse({
      data,
    });
  } catch (error) {
    if (error?.response?.status) {
      return new ServiceResponse({ error: error.response.status });
    }
    return new ServiceResponse({ error });
  }
};

export default getVendorsFood;
